/* v8 ignore start -- @preserve */

export const DocumentExtentions = {
  CSV: "csv",
  DOC: "doc",
  DOCX: "docx",
  JPEG: "jpeg",
  JPG: "jpg",
  JPGUppercased: "JPG",
  PDF: "pdf",
  PNG: "png",
  PPT: "ppt",
  PPTX: "pptx",
  TXT: "txt",
  XLSX: "xlsx",
  XML: "xml",
};

export const CSV_MIME_TYPES = {
  "text/csv": [DocumentExtentions.CSV],
};

export const PDF_MIME_TYPES = {
  "application/pdf": [DocumentExtentions.PDF],
};

export const WORD_MIME_TYPES = {
  "application/msword": [DocumentExtentions.DOC],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    DocumentExtentions.DOCX,
  ],
};

export const DEFAULT_UPLOAD_MIME_TYPES = {
  "application/msword": [DocumentExtentions.DOC],

  "application/vnd.ms-powerpoint": [DocumentExtentions.PPT],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    DocumentExtentions.PPTX,
  ],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    DocumentExtentions.XLSX,
  ],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    DocumentExtentions.DOCX,
  ],
  "application/xml": [DocumentExtentions.XML],
  "image/*": [
    DocumentExtentions.JPG,
    DocumentExtentions.JPEG,
    DocumentExtentions.PNG,
    DocumentExtentions.JPGUppercased,
  ],
  "text/plain": [DocumentExtentions.TXT],
  "text/xml": [DocumentExtentions.XML],
  ...CSV_MIME_TYPES,
  ...PDF_MIME_TYPES,
};
